import { FunctionComponent } from 'react';

interface TagImageProps {
    src: string;
    size?: number;
    alt?: string;
    className?: string;
}

const TagImage: FunctionComponent<TagImageProps> = props => {
    const style = {
        width: props.size ?? 24,
        height: props.size ?? 24,
        borderRadius: '50%'
    };

    return (
        <img
            src={props.src}
            alt={props.alt}
            style={style}
            className={props.className}
        />
    );
};

export default TagImage;
